/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Lines_No_Vehicle_RestInputs */

const fr_map_lines_no_vehicle_rest = /** @type {(inputs: Map_Lines_No_Vehicle_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun véhicule ne circule sur le reste du réseau.`)
};

const en_map_lines_no_vehicle_rest = /** @type {(inputs: Map_Lines_No_Vehicle_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No vehicle is running on the rest of the network.`)
};

/**
* | output |
* | --- |
* | "No vehicle is running on the rest of the network." |
*
* @param {Map_Lines_No_Vehicle_RestInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_lines_no_vehicle_rest = /** @type {((inputs?: Map_Lines_No_Vehicle_RestInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Lines_No_Vehicle_RestInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_lines_no_vehicle_rest(inputs)
	return en_map_lines_no_vehicle_rest(inputs)
});